import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';

const UploadedEssays = () => {
  const [showModal, setShowModal] = useState(false);
  const [essays, setEssays] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch uploaded essays data
    fetchUploadedEssays();
  }, []);

  const fetchUploadedEssays = async () => {
    try {
      const response = await axios.get(`https://backend.writerswright.com/api/v1/student/getUploadedEssays?Id=${Cookies.get('id')}`); // Replace with your endpoint
      console.log(response.data); // Log response for debugging
      setEssays(response.data.essays); // Assuming 'essays' is the key containing the array of essays in your response
    } catch (error) {
      console.error('Error fetching uploaded essays:', error);
      alert('Failed to fetch uploaded essays. Please check the server logs.');
    }
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const [formData, setFormData] = useState({
    userId: Cookies.get('id'),
    title: '',
    deadline: '',
    completeDetails: '',
    file: null  // Initialize file state
  });
  
  const handleSubmit = async (event) => {
    event.preventDefault();
  
    try {
      const response = await axios.post('https://backend.writerswright.com/api/v1/student/uploadEassy', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      const { sessionUrl } = response.data;
      console.log(sessionUrl)
      window.location.href = sessionUrl;
      handleClose();  // Close modal after successful upload
      fetchUploadedEssays(); // Refresh the list of essays
    } catch (error) {
      console.error('Error uploading essay:', error);
      alert('Failed to upload essay. Please check the server logs.');
    }
  };
  
  const handleInputChange = (event) => {
    const { name, value, files } = event.target;
    if (files) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: files[0], // Assuming single file upload
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };
  

  const navigateToEssayDetails = () => {
    navigate('/students-portal/essay-details');
  };

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3 alltitles">
        <h4 className='titleone'>Uploaded Essays</h4>
        <button className='button-37' onClick={handleShow}>Upload Essays</button>
      </div>

      {/* Modal for uploading essays */}
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Essay</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="essayTitle">
              <Form.Label>Essay Title</Form.Label>
              <Form.Control type="text" placeholder="Enter essay title" name="title" value={formData.title} onChange={handleInputChange} required />
            </Form.Group>
            <Form.Group controlId="deadline">
              <Form.Label>Select Deadline</Form.Label>
              <Form.Control type="date" name="deadline" value={formData.deadline} onChange={handleInputChange} required />
            </Form.Group>
            <Form.Group controlId="file">
              <Form.Label>Upload File</Form.Label>
              <Form.Control type="file" name="file" onChange={handleInputChange} required />
            </Form.Group>
            <Form.Group controlId="completeDetails">
              <Form.Label>Complete Details/Reference</Form.Label>
              <Form.Control as="textarea" rows={3} name="completeDetails" value={formData.completeDetails} onChange={handleInputChange} required />
            </Form.Group>
            <button className='button-37 mt-2' type="submit">
              Upload
            </button>
          </Form>
        </Modal.Body>
      </Modal>

      <div className='tables'>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Sr</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Essay</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Due Date</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Status</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Download</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Details</th>
            </tr>
          </thead>
          <tbody>
            {essays.map((essay, index) => (
              <tr key={essay.Id}>
                <td>{index + 1}</td>
                <td>{essay.Title}</td>
                <td>{new Date(essay.deadline).toLocaleDateString()}</td>
                <td>{essay.Status}</td>
                <td><a href={`https://backend.writerswright.com/${essay.document}`} style={{ color: "black" }}>Download Document</a></td>
                <td><button onClick={()=>{Cookies.set('essayId', essay.Id);navigateToEssayDetails();}} style={{ color: "black", background: "none", border: "none", textDecoration: "underline" }}>View More</button></td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
}

export default UploadedEssays;
